// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autocomplete_headerContainer__kPvFW{
    position: sticky;
    width: 100%;
    height: 75px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background:#FFFF;
    padding-left: 6rem;
    padding-right: 6rem;
    box-shadow: 4.33px 4.33px 6.18px rgba(1, 1, 1, 0.15);
}

.autocomplete_headerContainerItemLogo__cpUgz a{
    display: inline;
}

.autocomplete_headerLogo__cixPQ {
    margin-left: 20%;
    width:100%;
    height:2.5rem;
}

.autocomplete_headerText__7nxgn{
    font-size: 20px;
    text-decoration: none;
    font-family: var(--goldplay-regular);
    color:var(--gray-8);
    transform: translate(7vw,-3.65vh);
}

.autocomplete_headerText__7nxgn span{
    font-family: var(--goldplay-semibold-alt);
    font-weight: 800;
    color:var(--secundary)
}

.autocomplete_headerContainerItemBusca__-s3jC{
    display: flex;
    align-items: center;
}

.autocomplete_headerContainerItemBusca__-s3jC input{
    background: var(--gray-2);
    border-radius: 20px;
    font-size: 18px;
    padding: 15px;
    height: 50px;
    width: 575px;
    z-index: 0;
    box-shadow: 4.33px 4.33px 6.18px rgba(1, 1, 1, 0.15);
}

.autocomplete_headerContainerItemBusca__-s3jC ::placeholder{
    padding-left: 10px;
    font-family: var(--goldplay-regular);
    color: var(--gray-11);
}

.autocomplete_headerContainerItemBuscaButton__b0469{
    z-index: 1;
    transform: translate(-3.67vw,0);
    height:20px;
    width: 40px;
    background-color: var(--gray-2);
    display: grid;
    place-items: center;
    border-right: 1px solid var(--gray-9);
    
}

.autocomplete_headerContainerItemBuscaButton__b0469 img{
    width: 30px;
    height: 30px;
    transform: translate(-30%,-24%);
}

.autocomplete_headerContainerItemLocalizacaoButton__NIOdn{
    z-index: 1;
    transform: translate(-3.60vw,0);
    height:40px;
    width: 40px;
    background-color: var(--gray-2);
    display: grid;
    place-items: center;
    
}

.autocomplete_headerContainerItemLocalizacaoButton__NIOdn img{
    width: 30px;
    height: 35px;
    transform: translate(10%,-5%);
}

@media only screen and (min-width:320px)  and (max-width:480px){}
@media only screen and (min-width:576px)  and (max-width:640px){}
@media only screen and (min-width:768px)  and (max-width:992px){}


@media only screen and (min-width:1280px){
    .autocomplete_headerContainerItemLogo__cpUgz {
        transform: translate(-5vw,0);
    }


    .autocomplete_headerContainerItemBusca__-s3jC input{
        border-radius: 20px;
        transform: translate(7vw,0);    
        
    }

    .autocomplete_headerContainerItemBuscaButton__b0469{
        transform: translate(-0.67vw,0);    
    }
    

    .autocomplete_headerContainerItemLocalizacaoButton__NIOdn{ 
        transform: translate(-0.60vw,0);
    }

    .autocomplete_headerText__7nxgn{
        transform: translate(14.5vw,-3.45vh);
    }

}


@media only screen and (min-width:1366px){

    .autocomplete_headerContainerItemLogo__cpUgz {
        transform: translate(-3vw,-1vh);
    }

    .autocomplete_headerLogo__cixPQ{
        transform: translate(0,1vh);
    }

    .autocomplete_headerContainerItemBusca__-s3jC input{
        border-radius: 20px;
        transform: translate(7vw,0);    
        
    }

    .autocomplete_headerContainerItemBuscaButton__b0469{
        transform: translate(0vw,0);    
    }
    

    .autocomplete_headerContainerItemLocalizacaoButton__NIOdn{ 
        transform: translate(0vw,0);
    }

}


@media only screen and (min-width:1600px){
    .autocomplete_headerContainerItemLogo__cpUgz {
        transform: translate(0vw,0vh);
    }

    .autocomplete_headerLogo__cixPQ{
        transform: translate(0,0vh);
    }


    .autocomplete_headerContainerItemBusca__-s3jC input{
        border-radius: 20px;
        transform: translate(0vw,0);    
        
    }

    .autocomplete_headerContainerItemBuscaButton__b0469{
        transform: translate(-6vw,0);    
    }
    

    .autocomplete_headerContainerItemLocalizacaoButton__NIOdn{ 
        transform: translate(-5.8vw,0);
    }
}


@media only screen and (min-width: 1920px) {
    .autocomplete_headerLogo__cixPQ{
        transform: translate(0vw,0vh);
    }
    .autocomplete_headerContainerItemBuscaButton__b0469{
        transform: translate(-5vw,0);
    }
    
    .autocomplete_headerContainerItemLocalizacaoButton__NIOdn{
        transform: translate(-4.8vw,0);    
    }    
}


 

@media only screen and (min-width:2560px){
    .autocomplete_headerLogo__cixPQ{
        transform: translate(15vw,0vh);
    }
    .autocomplete_headerContainerItemBusca__-s3jC input{
        border-radius: 20px;
        transform: translate(-6vw,0);         
    }

    .autocomplete_headerContainerItemBuscaButton__b0469{
        transform: translate(-9.8vw,0);
    }
    
    .autocomplete_headerContainerItemLocalizacaoButton__NIOdn{
        transform: translate(-9.5vw,0);    
    }    
}



@media only screen and (min-width:3840px){}`, "",{"version":3,"sources":["webpack://./src/Views/Mapa/autoComplete/autocomplete.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,oCAAoC;IACpC,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,+BAA+B;IAC/B,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,qCAAqC;;AAEzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,+BAA+B;IAC/B,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA,gEAAgE;AAChE,gEAAgE;AAChE,gEAAgE;;;AAGhE;IACI;QACI,4BAA4B;IAChC;;;IAGA;QACI,mBAAmB;QACnB,2BAA2B;;IAE/B;;IAEA;QACI,+BAA+B;IACnC;;;IAGA;QACI,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;IACxC;;AAEJ;;;AAGA;;IAEI;QACI,+BAA+B;IACnC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;QACnB,2BAA2B;;IAE/B;;IAEA;QACI,2BAA2B;IAC/B;;;IAGA;QACI,2BAA2B;IAC/B;;AAEJ;;;AAGA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;;IAGA;QACI,mBAAmB;QACnB,2BAA2B;;IAE/B;;IAEA;QACI,4BAA4B;IAChC;;;IAGA;QACI,8BAA8B;IAClC;AACJ;;;AAGA;IACI;QACI,6BAA6B;IACjC;IACA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;AACJ;;;;;AAKA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,mBAAmB;QACnB,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;AACJ;;;;AAIA,0CAA0C","sourcesContent":[".headerContainer{\n    position: sticky;\n    width: 100%;\n    height: 75px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background:#FFFF;\n    padding-left: 6rem;\n    padding-right: 6rem;\n    box-shadow: 4.33px 4.33px 6.18px rgba(1, 1, 1, 0.15);\n}\n\n.headerContainerItemLogo a{\n    display: inline;\n}\n\n.headerLogo {\n    margin-left: 20%;\n    width:100%;\n    height:2.5rem;\n}\n\n.headerText{\n    font-size: 20px;\n    text-decoration: none;\n    font-family: var(--goldplay-regular);\n    color:var(--gray-8);\n    transform: translate(7vw,-3.65vh);\n}\n\n.headerText span{\n    font-family: var(--goldplay-semibold-alt);\n    font-weight: 800;\n    color:var(--secundary)\n}\n\n.headerContainerItemBusca{\n    display: flex;\n    align-items: center;\n}\n\n.headerContainerItemBusca input{\n    background: var(--gray-2);\n    border-radius: 20px;\n    font-size: 18px;\n    padding: 15px;\n    height: 50px;\n    width: 575px;\n    z-index: 0;\n    box-shadow: 4.33px 4.33px 6.18px rgba(1, 1, 1, 0.15);\n}\n\n.headerContainerItemBusca ::placeholder{\n    padding-left: 10px;\n    font-family: var(--goldplay-regular);\n    color: var(--gray-11);\n}\n\n.headerContainerItemBuscaButton{\n    z-index: 1;\n    transform: translate(-3.67vw,0);\n    height:20px;\n    width: 40px;\n    background-color: var(--gray-2);\n    display: grid;\n    place-items: center;\n    border-right: 1px solid var(--gray-9);\n    \n}\n\n.headerContainerItemBuscaButton img{\n    width: 30px;\n    height: 30px;\n    transform: translate(-30%,-24%);\n}\n\n.headerContainerItemLocalizacaoButton{\n    z-index: 1;\n    transform: translate(-3.60vw,0);\n    height:40px;\n    width: 40px;\n    background-color: var(--gray-2);\n    display: grid;\n    place-items: center;\n    \n}\n\n.headerContainerItemLocalizacaoButton img{\n    width: 30px;\n    height: 35px;\n    transform: translate(10%,-5%);\n}\n\n@media only screen and (min-width:320px)  and (max-width:480px){}\n@media only screen and (min-width:576px)  and (max-width:640px){}\n@media only screen and (min-width:768px)  and (max-width:992px){}\n\n\n@media only screen and (min-width:1280px){\n    .headerContainerItemLogo {\n        transform: translate(-5vw,0);\n    }\n\n\n    .headerContainerItemBusca input{\n        border-radius: 20px;\n        transform: translate(7vw,0);    \n        \n    }\n\n    .headerContainerItemBuscaButton{\n        transform: translate(-0.67vw,0);    \n    }\n    \n\n    .headerContainerItemLocalizacaoButton{ \n        transform: translate(-0.60vw,0);\n    }\n\n    .headerText{\n        transform: translate(14.5vw,-3.45vh);\n    }\n\n}\n\n\n@media only screen and (min-width:1366px){\n\n    .headerContainerItemLogo {\n        transform: translate(-3vw,-1vh);\n    }\n\n    .headerLogo{\n        transform: translate(0,1vh);\n    }\n\n    .headerContainerItemBusca input{\n        border-radius: 20px;\n        transform: translate(7vw,0);    \n        \n    }\n\n    .headerContainerItemBuscaButton{\n        transform: translate(0vw,0);    \n    }\n    \n\n    .headerContainerItemLocalizacaoButton{ \n        transform: translate(0vw,0);\n    }\n\n}\n\n\n@media only screen and (min-width:1600px){\n    .headerContainerItemLogo {\n        transform: translate(0vw,0vh);\n    }\n\n    .headerLogo{\n        transform: translate(0,0vh);\n    }\n\n\n    .headerContainerItemBusca input{\n        border-radius: 20px;\n        transform: translate(0vw,0);    \n        \n    }\n\n    .headerContainerItemBuscaButton{\n        transform: translate(-6vw,0);    \n    }\n    \n\n    .headerContainerItemLocalizacaoButton{ \n        transform: translate(-5.8vw,0);\n    }\n}\n\n\n@media only screen and (min-width: 1920px) {\n    .headerLogo{\n        transform: translate(0vw,0vh);\n    }\n    .headerContainerItemBuscaButton{\n        transform: translate(-5vw,0);\n    }\n    \n    .headerContainerItemLocalizacaoButton{\n        transform: translate(-4.8vw,0);    \n    }    \n}\n\n\n \n\n@media only screen and (min-width:2560px){\n    .headerLogo{\n        transform: translate(15vw,0vh);\n    }\n    .headerContainerItemBusca input{\n        border-radius: 20px;\n        transform: translate(-6vw,0);         \n    }\n\n    .headerContainerItemBuscaButton{\n        transform: translate(-9.8vw,0);\n    }\n    \n    .headerContainerItemLocalizacaoButton{\n        transform: translate(-9.5vw,0);    \n    }    \n}\n\n\n\n@media only screen and (min-width:3840px){}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `autocomplete_headerContainer__kPvFW`,
	"headerContainerItemLogo": `autocomplete_headerContainerItemLogo__cpUgz`,
	"headerLogo": `autocomplete_headerLogo__cixPQ`,
	"headerText": `autocomplete_headerText__7nxgn`,
	"headerContainerItemBusca": `autocomplete_headerContainerItemBusca__-s3jC`,
	"headerContainerItemBuscaButton": `autocomplete_headerContainerItemBuscaButton__b0469`,
	"headerContainerItemLocalizacaoButton": `autocomplete_headerContainerItemLocalizacaoButton__NIOdn`
};
export default ___CSS_LOADER_EXPORT___;
